import { MonitorDot, Package, Warehouse, Archive, Box, Palette } from "lucide-react";

const menuData: any = [
  {
    id: "dashboard",
    label: 'Dashboard',
    link: "/dashboard",
    icon: <MonitorDot />,
  },
  {
    id: 'warehouse-list',
    label: 'Warehouses',
    link: '/warehouse-list',
    icon: <Warehouse />,
  },
  {
    id: 'rack-list',
    label: 'Racks',
    link: '/rack-list',
    icon: <Archive />,
  },
  {
    id: 'bin-list',
    label: 'Bins',
    link: '/bin-list',
    icon: <Box />,
  },
  {
    id: 'item-group-list',
    label: 'Item Groups',
    link: '/item-group-list',
    icon: <Package />,
  },
  {
    id: 'item-list',
    label: 'Items',
    link: '/item-list',
    icon: <Package />,
  },
  {
    id: 'pantone-color-list',
    label: 'Pantone Colors',
    link: '/pantone-color-list',
    icon: <Palette />,
  },
];



export const UserPermissions: any = [
  {
    resource: "warehouses"
  },
  {
    resource: "racks"
  },
  {
    resource: "bins"
  },
  {
    resource: "item-groups"
  },
  {
    resource: "items"
  },
  {
    resource: "pantone-colors"
  },
  {
    resource: "item-stocks"
  },
  {
    resource: "item-rgb-color-stock"
  }
]

export { menuData };